import { render, staticRenderFns } from "./layoutLogo.vue?vue&type=template&id=0dd4ffc0&scoped=true&"
import script from "./layoutLogo.vue?vue&type=script&lang=js&"
export * from "./layoutLogo.vue?vue&type=script&lang=js&"
import style0 from "./layoutLogo.vue?vue&type=style&index=0&id=0dd4ffc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4ffc0",
  null
  
)

export default component.exports